// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBGvPcBFRcs32Q_OFCgpgO2gp4pSZBDOGs",
  authDomain: "hidnu-fm.firebaseapp.com",
  projectId: "hidnu-fm",
  storageBucket: "hidnu-fm.appspot.com",
  messagingSenderId: "183676676005",
  appId: "1:183676676005:web:83799a001383c00056aa4c",
  measurementId: "G-L8YWHQ8C66",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db, analytics };
